import { render, staticRenderFns } from "./CPopUp.vue?vue&type=template&id=3385b9da&scoped=true&"
import script from "./CPopUp.vue?vue&type=script&lang=ts&"
export * from "./CPopUp.vue?vue&type=script&lang=ts&"
import style0 from "./CPopUp.vue?vue&type=style&index=0&id=3385b9da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3385b9da",
  null
  
)

export default component.exports